module.exports = require('./helpers/bundle-url').getBundleURL('hTOHX') + "logo.c51670a8.svg";